<script lang="ts">
	import SlideIn from '$lib/transitions/slideIn.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			delay: number;
			duration: number;
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<SlideIn duration={content.duration || 1000} delay={content.delay || 0}>
	{#each content.body as block}
		<Blok content={block} />
	{/each}
</SlideIn>
